import { Component, OnInit, Input, Output, ViewChild, TemplateRef, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReportService } from '../../../services/index';
import { GridOptions } from '../../../common/ag-grid/ag-grid.model';
@Component({
    selector: 'app-report-bundle',
    styleUrls: ['./bundle.component.scss'],
    templateUrl: './bundle.component.html'
})
export class BundleReportComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input('tabID') tabID: string;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();
    order_no: any = '';
    loading = false;
    coreGang = [];
    menu : any;
    data: any = {

    };
    filter: any = {
        core_gang : ''
    };
    detail: any = {};
    gridOptions: GridOptions;
    columnDefs: any[];
    rowData: any[] = [];
    @ViewChild('tabContent') tabContent;
    @ViewChild('entryContainer') entryContainer;
    @ViewChild('listContainer') listContainer;
    constructor(private service: ReportService, private dp: DatePipe) {
        this.loadGrid();
    }

    printConfig: any = {
        title: 'Order Form Stock',
        columns: [],
        rows: []
    };

    ngOnInit(): void {
        if(this.menu.param == 'GangCore'){
            this.coreGang = ['CORE','GANG'];
            this.filter.core_gang = "CORE";
          }else{
            this.coreGang = ['NEW','ALL'];
            this.filter.core_gang = "ALL";
          }
        this.loadReport();
    }

    applyFilter(): void {
        this.loadReport();
    }
    loadReport() {
        this.loading = true;
        let params = {
            filter : JSON.stringify(this.filter)
        }
        this.data = {};
        this.service.getBundleStockReport(params).then((res: any) => {
            if (res.success) {
                this.data = res;
                this.detail = res.detail;
                this.gridOptions.setData(res.data);
            }
            this.loading = false;
        }).catch((err) => {
            this.loading = false;
        });
    }

    loadGrid() {
        const columns: any[] = [{
            headerName: 'Party',
            field: 'party_name',
        }, {
            headerName: 'Ref No',
            field: 'ref_no',
            width:100,
            maxWidth:100,
            minWidth:100
        },{
            headerName: 'Invoice No',
            field: 'invoice_no',
            width:150,
            maxWidth:150,
            minWidth:150
        },  
        // {
        //     headerName: 'Private Mark',
        //     field: 'pvt_mark',
        //     width:150,
        //     maxWidth:150,
        //     minWidth:150
        // },
         {
            headerName: 'Meters',
            field: 'totalqty',
            width:110,
            maxWidth:110,
            minWidth:110,
            summary: 'sum',
        }, {
            headerName: 'Amount',
            field: 'totalamt',
            summary: 'sum',
        },
        //  {
        //     headerName: 'Aging',
        //     type: 'number',
        //     width:100,
        //     maxWidth:100,
        //     minWidth:100
        // },
        {
            headerName: 'Bales',
            field: 'no_of_bales',
            width:100,
            maxWidth:100,
            minWidth:100
        },
        {
            headerName: 'Rec.Date',
            field: 'lrrec_date',
            width:100,
            maxWidth:100,
            minWidth:100 
        },
        {
            headerName: 'Aging',
            field: 'ageing',
            width:100,
            maxWidth:100,
            minWidth:100 
        }
    ];
        this.columnDefs = columns;
        this.rowData = [];
        this.gridOptions = new GridOptions({
            floatingBottomRowData: [{
            }],
            columnDefs: this.columnDefs,
            rowData: this.rowData,
        });
    }
    getListContainerStyle() {
      const style: any = {};
         let offsetHeight = window.innerHeight;
         if (this.tabContent) {
             offsetHeight = this.tabContent.nativeElement.offsetHeight;
         }
         offsetHeight -= 15;
         if (this.listContainer) {
             offsetHeight -= this.listContainer.nativeElement.offsetHeight;
         }
         style.height = offsetHeight + 'px';
         return style; 
    }
    getFormattedDate(so_date) {
        return this.dp.transform(new Date(so_date), 'dd-MM-yyyy');
    }

    exportToExcel($event) {

    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/reportlist/bundle-stock/bundle.component.ts